import { render, staticRenderFns } from "./ExpenseView.vue?vue&type=template&id=00a9d90e&"
import script from "./ExpenseView.vue?vue&type=script&lang=ts&"
export * from "./ExpenseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports